<div class="container-customer-data">
  <div class="bodyForm">
    <div class="container-input">
      <label for="createdAt">Inicio de conversación </label>
      <div class="data">{{ getFormattedDate(created_at) }}</div>
    </div>
    <div class="container-input">
      <label for="channel">Canal</label>
      <div class="data">{{ channel }}</div>
    </div>
    <div class="container-input">
      <label for="sender_name">Nombre</label>
      <div class="input-container">
        <input
          type="text"
          class="input data"
          [(ngModel)]="name"
          (input)="handleInput('sender_name', $event)"
          placeholder="Agregar"
          maxlength="18"
        />
      </div>
      <div *ngIf="errorMessages['sender_name']" class="error">
        {{ errorMessages['sender_name'] }}
      </div>
    </div>

    <div class="container-input">
      <label for="sender_phone">Teléfono</label>
      <div class="input-container">
        <input
          type="tel"
          class="input data"
          [(ngModel)]="phone"
          [readonly]="channel === 'WHATSAPP'"
          (input)="handleInput('sender_phone', $event)"
          placeholder="Agregar"
          maxlength="15"
          pattern="[0-9]*"
          inputmode="numeric"
          (keypress)="validateNumberInput($event)"
          [attr.disabled]="channel === 'WHATSAPP' ? true : null"
        />
      </div>
      <div *ngIf="errorMessages['sender_phone']" class="error">
        {{ errorMessages['sender_phone'] }}
      </div>
    </div>

    <div class="container-input">
      <label for="sender_email">Email</label>
      <div class="input-container">
        <input
          type="email"
          class="input data"
          [(ngModel)]="email"
          (input)="handleInput('sender_email', $event)"
          placeholder="Agregar"
          maxlength="50"
        />
      </div>
      <div *ngIf="errorMessages['sender_email']" class="error">
        {{ errorMessages['sender_email'] }}
      </div>
    </div>

    <div class="container-input requirement">
      <label for="sender_requirement">Notas</label>
      <div class="input-container">
        <textarea
          class="input data requirementInput"
          [(ngModel)]="sender_requirement"
          (input)="handleInput('sender_requirement', $event)"
          rows="3"
          placeholder="Agregar"
          maxlength="50"
        >
        </textarea>
      </div>
      <div *ngIf="errorMessages['sender_requirement']" class="error">
        {{ errorMessages['sender_requirement'] }}
      </div>
    </div>

    <div class="form-actions">
      <button class="btn btn-cancel" (click)="cancelChanges()">
        Cancelar
      </button>
      <button class="btn btn-save" (click)="saveChanges()" [disabled]="loading || !formChanged">
        <span *ngIf="!loading && !success">Guardar</span>
        <span *ngIf="loading" class="spinner"></span>
        <span *ngIf="!loading && success" class="success-icon">✓</span>
      </button>
    </div>
  </div>
</div>
